import {} from "reflect-metadata";
import { DataType } from "../../enums/shared/enums";

export function TableColumns(target: any) {
    const original = target;

    function construct(constructor, args) {
        console.log("construct");

        const c: any = function () {
            return constructor.apply(this, args);
        };

        c.prototype = constructor.prototype;
        return new c();
    }

    const f: any = function (...args) {
        const obj = construct(original, args);
        const properties = Object.getOwnPropertyNames(obj);
        const titles: any = {};
        const types: any = {};
        const pipes: any = {};

        properties.forEach((prop) => {
            const title = Reflect.getMetadata("column-title", this, prop);
            if (title) {
                titles[prop] = title;
            }

            const type = Reflect.getMetadata("column-type", this, prop);
            if (type !== undefined) {
                types[prop] = type;
            } else {
                types[prop] = DataType.string;
            }
        });

        obj["columns"] = titles;
        obj["types"] = types;
        return obj;
    };

    f.prototype = original.prototype;
    return f;
}
